//! Import the necessary modules
import { API_URI } from "../../constants/consts";
import { defineCancelApiObject } from "./configs/axiosUtils";

//* Schemas Import
import { loginSchema } from "../../schemas/authSchemas";

//* Axios
import { api } from "./configs/axiosConfigs";

export const AuthAPI = {
  changePasswordFirstLogin: async function (
    token: string,
    password: string,
    cancel = false
  ) {
    return api
      .request({
        url: `${API_URI}/admin/private/users/change-password`,
        method: "POST",
        headers: {
          Authorization: token,
        },
        data: { password: password },
        // signal: cancel
        //   ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        //   : undefined,
      })
      .then((response) => {
        return response.data;
      });
  },

  authorize: async function (cpf: string, password: string, cancel = false) {
    try {
      const validatedData = loginSchema.parse({ cpf: cpf, password });
      
      return api
        .request({
          url: `${API_URI}/student_portal/public/login`,
          method: "POST",
          data: { cpf: validatedData.cpf, password: validatedData.password },
          // signal: cancel
          //   ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          //   : undefined,
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          // Retornar um objeto estruturado mesmo em caso de erro
          return { 
            result: false, 
            message: e.response?.data?.message || "Erro ao conectar com o servidor" 
          };
        });
    } catch (error) {
      console.error("Erro de validação:", error);
      return { 
        result: false, 
        message: "Dados de login inválidos. Verifique seu CPF e senha." 
      };
    }
  },

  me: async function (token: string, cancel = false) {
    return api.request({
      url: `${API_URI}/student_portal/public/me`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      // signal: cancel
      //   ? cancelApiObject[this.getAll.name].handleRequestCancellation().signal
      //   : undefined,
    })
    .then((response) => {
      const payload = response.data;
      return payload;
    }).catch((e)=>{
      return e;
    });
  },

  
  
};
// defining the cancel API object for ProductAPI
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cancelApiObject = defineCancelApiObject(AuthAPI);